import React from 'react'
const Hero = () => {
    return (
        <section className="bg-landing-bg bg-cover bg-center relative p-3">
            <div className="max-w-7xl mx-auto px-4 flex items-center min-h-[8vh] ">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div>
                        <h1 className="text-white md:text-4xl text-2xl font-bold leading-tight mb-6">
                            Breathe Freely, Live Fully with Lung Renew                        </h1>
                        <p className="text-gray-300 text-xl mb-8">
                            Unlock the secret to melt trapped mucus and reclaim effortless breathing.
                        </p>
                        <a
                            href="#pricing"
                            className="bg-blue-100 text-navy-900 px-8 py-3 rounded-md text-lg font-semibold hover:bg-white hover:-translate-y-1 duration-150 ease-in-out"
                        >
                            Order Now
                        </a>
                    </div>
                    <div className="relative">
                        <img
                            src="https://cdn.blackincae.com/product-images/LungRenewBottleBox60ML.png"
                            alt="Sinoclear Product"
                            className="object-contain"
                            s
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero
